<template>
  <div
      :class="isAboutRoot ? 'd-none' : 'd-flex d-none:t'"
      class="ai-center bg-gray20 bd-b-gray80 p-1 p-y-2"
      @click="goToMenu"
  >
    <vk-icon name="chevronleft" class="m-r-1"/>
    <span>Back</span>
  </div>
</template>

<script>
export default {
  name: 'menu-navigation-button',
  props: {
    isAboutRoot: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goToMenu () {
      // check if user came from a different site
      if (!this.$store.state.route.from.name) {
        return this.$router.push({ name: 'about' });
      }
      return this.$router.go(-1);
    },
  },
};
</script>
